import React, { useRef, useEffect } from 'react';
import FormField from './FormField';
import VerificationInput from '../personal-info/VerificationInput';

const FormFieldWithVerification = ({
  label,
  name,
  type,
  value,
  onChange,
  onBlur,
  placeholder,
  icon,
  isVerified,
  required,
  dir,
  error,

  showVerificationInput,
  verificationCode,
  onSendCode,
  onVerificationCodeChange,
  onVerify,
  verificationAttempts = 0,
  maxAttempts = 3,
  showVerificationButton = true
}) => {
  const verificationSectionRef = useRef(null);

  useEffect(() => {
    if (showVerificationInput && verificationSectionRef.current) {
      verificationSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [showVerificationInput]);

  return (
    <div className="relative">
      <FormField
        label={label}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        icon={icon}
        verified={isVerified}
        required={required}
        dir={dir}
        error={error}
        onSendCode={onSendCode}
        showVerificationButton={showVerificationButton && value && value.trim() !== ''}
        showVerificationInput={showVerificationInput}
      />

      {showVerificationInput && (
        <VerificationInput
          name={name}
          verificationCode={verificationCode}
          onVerificationCodeChange={onVerificationCodeChange}
          onVerify={onVerify}
          attempts={verificationAttempts}
          maxAttempts={maxAttempts}
          containerRef={verificationSectionRef}
        />
      )}
    </div>
  );
};

export default FormFieldWithVerification;